import primary from './primary'
import inverted from './inverted'

export default {
  primary,
  inverted
}